// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"16":"app-public","180":"app-main","532":"styles","918":"app-embed"}[chunkId] + ".css?" + {"16":"87a34085556465e066ce","180":"880ec9922f6aadc32170","532":"68b86bff4127d2dd3423","918":"87a34085556465e066ce"}[chunkId] + "";
};